import { Theme } from "@mui/material/styles";

/**
 * Shared backdrop styles for dialogs to maintain consistency across the app.
 * Uses light grey background with no backdrop filter for better UX.
 */
const getDialogBackdropStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.grey[100],
  backdropFilter: "none",
});

/**
 * Common dialog slot props with consistent backdrop styling.
 * Use this for consistent dialog appearance across the application.
 */
export const getDialogSlotProps = (
  theme: Theme,
  additionalPaperProps?: object
) => ({
  backdrop: {
    sx: getDialogBackdropStyles(theme),
  },
  ...(additionalPaperProps && {
    paper: additionalPaperProps,
  }),
});
